<template>
  <div>
    <h1>TESTS</h1>
    <template v-if="loadingTests">
      Loading ...
    </template>
    <template v-else-if="dbErrors.tests">
      {{ dbErrors.tests }}
    </template>
    <template v-else>
      <div 
        v-for="item in tests"
        :key="item.id">
        {{ item.id }} - {{ item.value }}
        <v-btn @click="goTest(item)">Go</v-btn>
        <v-btn @click="updateTest(item)">Update</v-btn>
        <v-btn @click="removeTest(item)">Delete</v-btn>
      </div>
      <div>
        Add 
        <input v-model="data.test.value">
        <v-btn @click="addTest">Add</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import TestsLib from '@/lib/data/tests'
const debug = require('debug')('OD::TestItems')

export default {
  name: 'TestItems',
  components: {},
  data() {
    return {
      data: {
        user: {},
        test: {
          value: '',
        },
      },
      loadingUsers: true,
      loadingTests: true,
      dbErrors: {
        users: '',
        tests: '',
      },
    }
  },
  computed: {},
  async mounted() {
    this.bind()
  },
  beforeDestroy() {
  },
  methods: {
    bind() {
      TestsLib.bindAll(this)
    },
    addTest() {
      if (this.data.test.value) {
        TestsLib.add(this, this.data.test)
      }
    },
    goTest(item) {
      debug('goTest1', item)
      this.$router.push({ name: 'TestItem', params: { itemId: item.id } })
    },
    updateTest(item) {
      debug('updateTest1', item)
      const updateData = { value: item.value + 'X' }
      TestsLib.update(this, item.id, updateData)
    },
    removeTest(item) {
      debug('removeTest', item)
      TestsLib.delete(this, item.id)
    },
  },
}
</script>

<style lang="scss">

</style>
